import React, { useContext } from 'react';
import styled from 'styled-components';
import { Context } from '../context';
import { Fallback, ScreenOrientation, ThemeScroll } from '../FeatureAppTypes';
import { AssetHelper } from '../helper/assetHelper';
import { useViewbox } from '../utils/use-viewbox';

interface StyledImageProps {
  backdropColor: string;
}

const StyledImage = styled.img<StyledImageProps>`
  width: 100%;
  background-color: ${({ backdropColor }) => backdropColor};
`;

interface Props {
  fallback: Fallback;
  theme: ThemeScroll;
}

export const StaticImage: React.FC<Props> = ({ fallback, theme }) => {
  const { logger } = useContext(Context);
  const { breakpoints, colors } = theme;
  const { orientation } = useViewbox();
  const { portrait, landscape, alt } = fallback;

  const imageSrc = `${AssetHelper.getImageUrl(
    orientation === ScreenOrientation.landscape ? landscape : portrait,
    logger,
  )}?width=`;

  return (
    <picture>
      <source
        srcSet={`${imageSrc}${breakpoints.l} 2x, ${imageSrc}${breakpoints.m}`}
        media={`(max-width: ${breakpoints.m}px)`}
      />
      <source
        srcSet={`${imageSrc}${breakpoints.xxl} 2x, ${imageSrc}${breakpoints.l}`}
        media={`(max-width: ${breakpoints.l}px)`}
      />
      <source
        srcSet={`${imageSrc}${breakpoints.xxl} 2x, ${imageSrc}${breakpoints.xxl}`}
        media={`(min-width: ${breakpoints.l}px)`}
      />
      <StyledImage
        src={`${imageSrc}${breakpoints.s}`}
        backdropColor={colors.colorCanvas200}
        alt={alt}
      />
    </picture>
  );
};
